class Dialog {
    constructor(title, content, options = {}) {
        this.title = title;
        this.content = content;
        this.options = options;
        this.events = [];
        this.buttons = [];
        this.modal = null;
        this._backdrop = null;
    }

    setEvents(events) {
        this.events = events;
        return this;
    }

    setButtons(buttons) {
        this.buttons = buttons;
        return this;
    }

    show() {
        const backdrop = document.createElement('div');
        backdrop.className = 'fixed inset-0 modal-backdrop z-[1000] flex items-center justify-center p-4';

        // Determine size class
        const sizeClass = {
            'lg': 'max-w-lg',
            'xl': 'max-w-xl',
            '2xl': 'max-w-2xl',
            '3xl': 'max-w-3xl'
        }[this.options.size] || 'max-w-lg';

        this.modal = document.createElement('div');
        this.modal.className = `bg-white rounded-xl shadow-2xl ${sizeClass} w-full max-h-[90vh] overflow-hidden flex flex-col`;

        const header = document.createElement('div');
        header.className = 'px-6 py-4 border-b border-gray-200 flex items-center justify-between';
        header.innerHTML = `
                    <h3 class="text-xl font-semibold text-gray-800">${this.title}</h3>
                    <button class="text-gray-400 hover:text-gray-600 text-xl">
                        <i class="fas fa-times"></i>
                    </button>
                `;

        header.querySelector('button').addEventListener('click', () => {
            this.hide();
        });

        const body = document.createElement('div');
        body.className = 'px-6 py-4 overflow-y-auto flex-grow';
        body.innerHTML = this.content;

        const footer = document.createElement('div');
        footer.className = 'px-6 py-4 border-t border-gray-200 flex justify-end space-x-3';

        if (this.buttons && this.buttons.length > 0) {
            this.buttons.forEach(btnConfig => {
                const button = document.createElement('button');
                button.className = `px-4 py-2 rounded-lg text-black font-medium ${btnConfig.class} transition-colors cursor-pointer`;
                button.textContent = btnConfig.name;

                if (btnConfig.dismiss) {
                    button.addEventListener('click', () => this.hide());
                }

                if (btnConfig.onClick) {
                    button.addEventListener('click', (e) => {
                        btnConfig.onClick.call(button, {
                            data: { modal: this.modal }
                        });
                    });
                }

                footer.appendChild(button);
            });
        } else {
            const closeButton = document.createElement('button');
            closeButton.className = 'px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium';
            closeButton.textContent = 'Close';
            closeButton.addEventListener('click', () => this.hide());
            footer.appendChild(closeButton);
        }

        this.modal.appendChild(header);
        this.modal.appendChild(body);
        this.modal.appendChild(footer);

        backdrop.appendChild(this.modal);
        document.body.appendChild(backdrop);

        // Store a direct reference to THIS dialog's backdrop so that hide()
        // always removes the correct element even when multiple dialogs are
        // stacked on top of each other (they previously all shared the same
        // id="dialogBackdrop", so the wrong one was removed on nested dialogs).
        this._backdrop = backdrop;

        this.events.filter(e => e.action === 'show').forEach(event => {
            event.callback({
                data: { modal: this.modal }
            });
        });

        backdrop.addEventListener('click', (e) => {
            if (e.target === backdrop) {
                this.hide();
            }
        });

        return this;
    }

    hide() {
        if (this._backdrop && this._backdrop.parentNode) {
            this._backdrop.parentNode.removeChild(this._backdrop);
            this._backdrop = null;
        } else if (this.modal) {
            // Fallback for any legacy path that didn't go through show().
            const backdrop = document.getElementById('dialogBackdrop');
            if (backdrop) {
                document.body.removeChild(backdrop);
            }
        }
        if (typeof this.onHide === 'function') {
            this.onHide();
        }
    }
}